import { dataFetch } from '@lib/ggj-utils'

export default {

	manageHomeHead(params) {
    return dataFetch('/wholesale/api/management/home/head', params, {
      method: 'get',
    })
  },
  manageHomeIncome(params) {
		return dataFetch('/wholesale/api/management/home/income', params, {
			method: 'get',
		})
	},
  manageHomeUpgradeGuide(params) {
		return dataFetch('/wholesale/api/management/home/upgrade/guide', params, {
			method: 'get',
		})
	},


	getRubanData(params) {
		return dataFetch('/ruban/api/res/data', params,{ method: 'get' })
	},

	getUserBaseInfo(params) {
		return dataFetch('/wholesale/api/auth/baseInfo',params, { method: 'get' })
	},

	getUserBaseInfo(params) {
		return dataFetch('/wholesale/api/auth/baseInfo',params, { method: 'get' })
	},

	managementGuide(params) {
		return dataFetch('/wholesale/api/management/home/guide/check',params, { method: 'get' })
	},
	checkClick(params) {
		return dataFetch('/wholesale/api/management/home/check/click',params, { method: 'get' })
	},
	markClick(params) {
		return dataFetch('/wholesale/api/management/home/mark/click',params, { method: 'get' })
	},

	managementFollow(params) {
		return dataFetch('/wholesale/api/management/home/followup',params, { method: 'get' })
	},


	agreementShow(params) {
		return dataFetch('/wholesale-activity/api/salary/agreement/show',params, { method: 'post' })
	},

	queryAgreementStatus(params) {
		return dataFetch('/wholesale-activity/api/salary/agreement/queryAgreementStatus',params, { method: 'post' })
	},

	agreementCallback(params) {
		return dataFetch('/wholesale-activity/api/salary/agreement/callback',params, { method: 'post' })
	},
	async getDynamic (data) {
		return dataFetch('/service/mps.xr.latestDynamic', data)
	},
	async getMedalInfo (data) {
		return dataFetch('/wholesale/api/management/medal/info', data, { method: 'get' })
	},
	async getDouble11 (data) {
		return dataFetch('/wholesale/api/management/double11/info', data, { method: 'get' })
	},
	async myCustomer (data) {
		return dataFetch('/wholesale/api/management/my/customer', data, { method: 'get' })
	},

	async getCommonAgreement (data) {
		return dataFetch('/user-customer-web/api/agreement/getCommonAgreement', data, { method: 'get' })
	},

	async depositBalance (data) {
		return dataFetch('/wholesale/api/deposit/balance', data, { method: 'get' })
	},

	async notifysCount (data) {
		return dataFetch('/service/mps.xr.notifysCount', data, { method: 'get' })
	}


}
